import React from 'react'
import PropTypes from 'prop-types'

import BasicViewComponent from './BasicViewComponent'
import ButtonBase from '@material-ui/core/ButtonBase'
import View from './View'

class FlatButton extends BasicViewComponent {

  constructor (props) {
    super(props)
    this.text = props.config.text
  }

  render () {
    if (!super.conditionsAreMet()) {
      return null
    }

    return (
      <ButtonBase
        className={this.cssClass}
        onClick={this.onTouchTap}
        variant={'flat'}
      >
        <View
          config={this.props.config.view}
          functions={this.props.functions}
          poi={this.props.poi}
          setCategoryVisible={this.props.setCategoryVisible}
      />
      </ButtonBase>
    )
  }

}

FlatButton.TYPE = 'flatButton'

FlatButton.propTypes = {
  config: PropTypes.object.isRequired,
  setCategoryVisible: PropTypes.func
}

export default FlatButton



// WEBPACK FOOTER //
// ./src/components/ViewComponents/FlatButton.js